<p-drawer
  [(visible)]="showDrawer"
  (onHide)="onHideDrawer()"
  position="right"
  closeIcon="pi pi-sign-out"
  styleClass="side-info-drawer"
>
  <ng-template #headless>
    <div class="flex flex-col h-screen overflow-auto">
      <div class="">
        <div class="flex align-items-center gap-3 p-6">
          <div class="flex-1">
            <div class="flex-1">
              <div class="text-color text-3xl font-semibold leading-normal">
                {{ entity.metadata.displayName }}
              </div>
              <div class="text-muted-color font-medium leading-normal">
                {{ entity.metadata.name }}
              </div>
            </div>
          </div>
          <p-button
            (onClick)="onHideDrawer()"
            icon="pi pi-sign-out"
            text
            rounded
            severity="secondary"
          />
        </div>
        <div class="flex align-items-center gap-5 p-1 px-6 py-3">
          <users-avatars-category
            [title]="'miscellaneous.owner.label'"
            [multipleAllowed]="false"
            [items]="owner"
            [allUsersResponse]="true"
            [entityType]="entityType"
            [entityUid]="entity.uid"
            [environmentUid]="environmentUid"
            [availableUsers]="availableUsers"
            [showChange]="entity.__hasAdminRights && !isNonSolutionFlow()"
            [userType]="'owner'"
            (availableUsersFetch)="onFetchUsers()"
            (itemsChange)="onChangedOwner($event)"
            (allUsersChange)="onAllUsersChange($event)"
            class="flex-1"
          ></users-avatars-category>
          <users-avatars-category
            [title]="'miscellaneous.deputies.label'"
            [multipleAllowed]="true"
            [items]="deputies"
            [allUsersResponse]="true"
            [entityType]="entityType"
            [entityUid]="entity.uid"
            [environmentUid]="environmentUid"
            [availableUsers]="availableUsers"
            [showChange]="entity.__hasAdminRights"
            [userType]="'deputies'"
            (availableUsersFetch)="onFetchUsers()"
            (itemsChange)="onChangedDeputies($event)"
            (allUsersChange)="onAllUsersChange($event)"
            class="flex-1 flex"
          ></users-avatars-category>
        </div>
        <div
          *ngIf="entityType !== 'ENVIRONMENT' && entityType !== 'BOT'"
          class="flex align-items-center gap-5 p-1 px-6 py-3"
        >
          <users-avatars-category
            [title]="'miscellaneous.shared.label'"
            [multipleAllowed]="true"
            [items]="shared"
            [allUsersResponse]="true"
            [entityType]="entityType"
            [entityUid]="entity.uid"
            [environmentUid]="environmentUid"
            [availableUsers]="availableUsers"
            [showChange]="entity.__hasAdminRights"
            [userType]="'shared'"
            [maxDisplay]="7"
            (availableUsersFetch)="onFetchUsers()"
            (itemsChange)="onChangedShared($event)"
            (allUsersChange)="onAllUsersChange($event)"
            class="flex-1 flex"
          ></users-avatars-category>
        </div>

        <div *ngIf="showActivityConfirmation()" class="w-full px-6 py-3">
          <div class="flex flex-row gap-4 justify-end">
            <div class="flex-1">
              <div class="text-muted-color font-medium leading-normal">
                <p-message class="mb-6" [severity]="'warn'">{{
                  "entity.details.needsActivityConfirmation.message" | translate
                }}</p-message>
              </div>
            </div>

            <p-button
              class="text-right"
              (click)="confirmActivity()"
              [disabled]="!entity.__hasAdminRights"
              [label]="
                'entity.details.needsActivityConfirmation.button' | translate
              "
            />
          </div>
        </div>
        <p-selectbutton
          [(ngModel)]="selectedSidebarOption"
          [options]="sidebarOptionsFiltered"
          [allowEmpty]="false"
          [unselectable]="true"
          (onChange)="changeTabSelect()"
          class="w-full px-6 py-3"
          styleClass="flex-1 w-full py-2.5"
        >
          <ng-template pTemplate="item" let-item>
            <span class="text-sm">{{
              "common.info.tab." + item + ".label" | translate
            }}</span>
          </ng-template>
        </p-selectbutton>
      </div>
      <div
        *ngIf="selectedSidebarOption === 'overview'"
        class="flex flex-row gap-4 p-6 flex-wrap"
      >
        <div
          *ngFor="let dataItem of dataItems"
          class="flex flex-col gap-2 100"
          [class.w-full]="!dataItem.halfWidth"
          [class.flex-1]="dataItem.halfWidth"
        >
          <label for="{{ dataItem.id }}">{{
            dataItem.label | translate
          }}</label>
          <input
            *ngIf="dataItem.type === 'text'"
            pInputText
            id="{{ dataItem.id }}"
            [disabled]="true"
            [value]="getDataItemValue(dataItem)"
          />
          <input
            *ngIf="dataItem.type === 'date'"
            pInputText
            id="{{ dataItem.id }}"
            [disabled]="true"
            [value]="getDataItemValue(dataItem) | date: 'mediumDate'"
          />
        </div>
      </div>
      <div
        *ngIf="selectedSidebarOption === 'preferences'"
        class="flex flex-1 flex-col gap-4 p-6"
      >
        <div
          *ngFor="let data of preferencesGroups"
          class="flex flex-col p-3 rounded-xl bg-emphasis"
        >
          <div class="leading-6 font-medium text-color p-2">
            {{ data.title | translate }}
          </div>
          <div
            class="overflow-y-auto flex-1 bg-surface-0 dark:bg-surface-900 mt-2 p-4 flex flex-col gap-3 rounded-lg"
          >
            <div
              *ngFor="let pref of data.items"
              class="flex items-center gap-2"
            >
              <i class="text-lg text-color" [class]="pref.icon"></i>
              <div
                [pTooltip]="pref.tooltip | translate"
                class="font-medium text-color flex-1"
              >
                {{ pref.title | translate }}
                <i
                  class="font-medium text-color"
                  [class]="'pi pi-info-circle'"
                ></i>
              </div>
              <p-toggleswitch
                [(ngModel)]="getFlags()[pref.checkedFlag]"
                (ngModelChange)="onFlagChange($event, pref.id)"
                [disabled]="!entity.__hasAdminRights"
              />
            </div>
          </div>
        </div>
      </div>
      <div
        *ngIf="selectedSidebarOption === 'compliance'"
        class="flex flex-1 flex-col gap-4 p-6"
      >
        <compliance-section
          [entityType]="entityType"
          [entityUid]="entity.uid"
          [environmentUid]="environmentUid"
          [isAdmin]="entity.__hasAdminRights"
          [filledCompliance]="entity.filledCompliance"
          (entityUpdated)="entityChange.emit($event)"
        ></compliance-section>
      </div>
    </div>
  </ng-template>
</p-drawer>
